(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("utils-library", [], factory);
	else if(typeof exports === 'object')
		exports["utils-library"] = factory();
	else
		root["utils-library"] = factory();
})(global, () => {
return 